import type React from "react";
import { dictionary } from "../../../utils/dictionary";
import { Language } from "../../../utils/dictionary";

interface ProductVariantsInfoProps {
  variantsAttributes: string[];
  language: Language;
}

export const ProductVariantsInfo: React.FC<ProductVariantsInfoProps> = ({
  variantsAttributes,
  language,
}) => {
  if (!variantsAttributes || variantsAttributes.length === 0) {
    return null;
  }

  return (
    <div className="mt-3 p-3 bg-blue-50 border border-blue-200 rounded-lg">
      <div className="flex items-start gap-2">
        <svg 
          className="w-5 h-5 text-blue-500 flex-shrink-0 mt-0.5" 
          fill="currentColor" 
          viewBox="0 0 20 20"
        >
          <path 
            fillRule="evenodd" 
            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" 
            clipRule="evenodd" 
          />
        </svg>
        <div className="flex-1">
          <p className="text-sm text-blue-800 mb-2">
            {dictionary["product-with-variants-message"][language] || 
             "Este producto se creará con variaciones basadas en la página de Dropi y quedará reflejado en el embudo creado"}
          </p>
          <div className="flex flex-wrap gap-2">
            {variantsAttributes.map((attribute: string) => (
              <span
                key={attribute}
                className="inline-flex items-center px-2 py-2 rounded-lg text-sm font-medium bg-[#EFF6FF] text-[#3B82F6] border border-[#3B82F6]"
              >
                {attribute}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductVariantsInfo;

